import { Link } from "react-router-dom";
import { useInbox } from "@/monitors/api";
import { MatchCard } from "./MatchCard";

export function BellDropdown({ onClose }: { onClose: () => void }) {
  const { data, isLoading, isError } = useInbox({ stage: "confirmed", limit: 10 });
  const matches = data?.matches ?? [];

  return (
    <div className="w-80 max-h-[480px] overflow-auto">
      <div className="p-3 border-b text-sm font-semibold">Recent matches</div>
      {isLoading && <div className="p-4 text-sm text-muted-foreground">Loading…</div>}
      {isError && (
        <div className="p-4 text-sm text-red-600">Couldn't load matches.</div>
      )}
      {!isLoading && matches.length === 0 && (
        <div className="p-4 text-sm text-muted-foreground">No matches yet.</div>
      )}
      <ul className="divide-y">
        {matches.map((m) => (
          <li key={m.id} className="p-2">
            <MatchCard match={m} monitorName="" size="sm" showWhy={false} />
          </li>
        ))}
      </ul>
      <div className="p-2 border-t text-center">
        <Link
          to="/monitors/matches"
          className="text-sm text-primary"
          onClick={onClose}
        >
          See all matches →
        </Link>
      </div>
    </div>
  );
}
